import { type AppDispatch } from '../../../store'
import { customDeviceListLoadingAction, customDeviceListUpdateAction, customDeviceListErrorAction } from './deviceListSlice'
import * as DeviceListService from '../services/customDeviceListService'
import { deviceDeleteLoadingAction, deviceDeleteUpdateAction, deviceDeleteErrorAction } from './deviceDeleteSlice'
import * as DeviceDeleteService from '../services/customeDeviceDeleteService'
import { uploadCustomDeviceFileInfoDataLoading, uploadCustomDeviceFileInfoDataError, uploadCustomDeviceFileInfoData, resetCustomDeviceUpload } from './createDeviceInfoSlice'
import * as deviceInfoService from '../services/createCustomTemplateService'
import * as exportGraphDataService from '../services/exportCustomDeviceData'
import { exportCustomDeviceDataLoadingAction, exportCustomDeviceDataUpdateAction, exportCustomDeviceDataErrorAction } from './exportCustomDeviceDataSlice'
import * as customDeviceService from '../services/getDeviceDropDownMeta'
import { DeviceDropDownMetadataLoadingAction, DeviceDropDownMetadataUpdateAction, DeviceDropDownMetadataErrorAction } from './getDeviceDropDownMetaDataSlice'
import * as getDeviceDataByIdService from '../services/getDeviceDetailsById'
import { customDeviceByIdLoadingAction, customDeviceByIdUpdateAction, customDeviceByIdErrorAction } from './getDeviceDataByIdSlice'
import * as updateDeviceTemplateService from '../services/updateDeviceDetails'
import { UpdateCustomDeviceFileInfoDataLoading, UpdateCustomDeviceFileInfoDataError, UpdateCustomDeviceFileInfoData } from './updateDeviceTemplateSlice'

export const fetchDeviceList = (PageNumber: number, PageItems: number, searchKey: string, SortParams: string, sortField: string) => async (dispatch: any): Promise<void> => {
  dispatch(customDeviceListLoadingAction())
  void DeviceListService.getDeviceList(
    PageNumber, PageItems, searchKey, SortParams, sortField,
    (customDeviceList, httpStatus) => {
      dispatch(customDeviceListUpdateAction({ data: customDeviceList.deviceTemplates, count: customDeviceList.total_count, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(customDeviceListErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const getDeviceDataById = (deviceId: string) => async (dispatch: any): Promise<void> => {
  dispatch(customDeviceByIdLoadingAction())
  void getDeviceDataByIdService.getDeviceDetailsById(
    deviceId,
    (customDeviceListByID: any, httpStatus) => {
      dispatch(customDeviceByIdUpdateAction({ data: customDeviceListByID, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(customDeviceByIdErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const deviceDeleteCampaign = (selectedDeviceId: string) => async (dispatch: AppDispatch): Promise<void> => {
  dispatch(deviceDeleteLoadingAction())
  void DeviceDeleteService.deviceDeleteCampaign(selectedDeviceId,
    (deleteStatusData, httpStatus) => {
      dispatch(
        deviceDeleteUpdateAction({ data: deleteStatusData, httpStatus })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(deviceDeleteErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const createCustomeDeviceTemplateService = (file: File, deviceTemplateRequest: any) => async (dispatch: any) => {
  dispatch(uploadCustomDeviceFileInfoDataLoading())
  try {
    await deviceInfoService.createCustomTemplateService(file, deviceTemplateRequest, (createCustomTemplate, httpStatus) => {
      dispatch(uploadCustomDeviceFileInfoData({ data: createCustomTemplate, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(uploadCustomDeviceFileInfoDataError({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    dispatch(uploadCustomDeviceFileInfoDataError(e))
  }
}

export const updateCustomeDeviceTemplateService = (deviceId: string, file: File, deviceTemplateRequest: any) => async (dispatch: any) => {
  dispatch(UpdateCustomDeviceFileInfoDataLoading())
  try {
    await updateDeviceTemplateService.UpdateCustomTemplateService(deviceId, file, deviceTemplateRequest, (UpdateCustomDevice, httpStatus) => {
      dispatch(UpdateCustomDeviceFileInfoData({ data: UpdateCustomDevice, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(UpdateCustomDeviceFileInfoDataError({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    dispatch(UpdateCustomDeviceFileInfoData(e))
  }
}

export const resetUpload = () => async (dispatch: any) => {
  dispatch(resetCustomDeviceUpload())
}

export const getExportCustomDeviceDataService = (deviceId: string, fileName: string) => async (dispatch: any) => {
  dispatch(exportCustomDeviceDataLoadingAction())
  try {
    await exportGraphDataService.exportCustomDeviceData(deviceId, fileName, (message: any) => {
      dispatch(exportCustomDeviceDataUpdateAction(message))
    },
    (errorMessage: any) => {
      dispatch(exportCustomDeviceDataErrorAction(errorMessage))
    })
  } catch (e: any) {
    dispatch(exportCustomDeviceDataErrorAction(e))
  }
}

export const getCustomDeviceDropdownMetadata = () => async (dispatch: any) => {
  dispatch(DeviceDropDownMetadataLoadingAction())
  void customDeviceService.getDeviceDropDownMeta((DeviceDropDownMetaDetails, httpStatus) => {
    dispatch(DeviceDropDownMetadataUpdateAction({ data: DeviceDropDownMetaDetails, httpStatus }))
  },
  (errorMessage, httpStatus) => {
    dispatch(DeviceDropDownMetadataErrorAction({ errorMessage, httpStatus }))
  })
}
